'use strict';
'use es6';

// Determine the target attr for an <a>, based on the props of the link component.

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTarget = exports.getTarget = function getTarget(_ref) {
  var external = _ref.external,
      target = _ref.target;

  if (target !== undefined) {
    return target;
  }
  if (external) {
    return '_blank';
  }
  return undefined;
};

// Determine the rel attr for an <a>, based on the link component's rel prop and the target attr.
var getRel = exports.getRel = function getRel(_ref2, _ref3) {
  var rel = _ref2.rel;
  var computedTarget = _ref3.computedTarget;

  if (rel !== undefined) {
    return rel;
  }
  if (computedTarget && computedTarget !== '_self') {
    // See https://mathiasbynens.github.io/rel-noopener/
    return 'noopener noreferrer';
  }
  return undefined;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/Links.js
// module id = 142
// module chunks = 0